import { render, staticRenderFns } from "./DotsShadowPreloader.vue?vue&type=template&id=96535f1c&scoped=true"
import script from "./DotsShadowPreloader.vue?vue&type=script&lang=js"
export * from "./DotsShadowPreloader.vue?vue&type=script&lang=js"
import style0 from "./DotsShadowPreloader.vue?vue&type=style&index=0&id=96535f1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96535f1c",
  null
  
)

export default component.exports